import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

// 👉 Paste your rawData and transform function here
const rawData = [
  {
    Metric: "Receipts",
    Department: "MAIN",
    "2025-09": 43187.5,
    "2025-08": 57739,
    "2025-07": 141534.16,
  },
  {
    Metric: "Payments",
    Department: "MAIN",
    "2025-09": 53500,
    "2025-08": 17029.7,
    "2025-07": 1600,
  },
  {
    Metric: "Receipts",
    Department: "BRANCH1",
    "2025-09": 12000,
    "2025-08": 15000,
    "2025-07": 11000,
  },
  {
    Metric: "Payments",
    Department: "BRANCH1",
    "2025-09": 11000,
    "2025-08": 13000,
    "2025-07": 9000,
  },
];

const data = transformRawData(rawData); // 🔄 Apply transformation

function transformRawData(rawData) {
  const result = [];

  // Get unique months
  const months = Array.from(
    new Set(
      rawData.flatMap(item =>
        Object.keys(item).filter(k => /^\d{4}-\d{2}$/.test(k))
      )
    )
  );

  const departments = Array.from(
    new Set(rawData.map(item => item.Department))
  );

  departments.forEach(branch => {
    months.forEach(month => {
      const entry = { branch, month };
      rawData.forEach(row => {
        if (row.Department === branch) {
          entry[row.Metric] = row[month] ?? 0;
        }
      });
      result.push(entry);
    });
  });

  return result;
}


export default function SalesLineChart3() {
  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <div style={{ width: `${data.length * 50}px`, minWidth: "1200px" }}>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart
            data={data}
            margin={{ top: 20, right: 30, bottom: 50, left: 20 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="branch"
              tickFormatter={(tick, index) => {
                const item = data[index];
                return item ? `${item.branch}\n${item.month}` : tick;
              }}
              interval={0}
              height={80}
              tickMargin={20}
            />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="Receipts" stackId="a" fill="#3b82f6" />
            <Bar dataKey="Payments" stackId="a" fill="#ef4444" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

